import { HISTORIC_AMOUNT } from '../../helpers/constants';
import { AmountField } from './eChartHelpers';

// Takes an hexadecimal color and returns the hexadecimal of the  same color
// with a transparent effect
const lighten = (hexColor: string, percent: number) => {
    // Convert hexadecimal to RGB
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);

    // calculate New opacity
    const newAlpha = Math.max(0, Math.min(1, 1 - percent));

    // Convert new values to hexadecimal
    const newHexColor = `rgba(${r}, ${g}, ${b}, ${newAlpha.toFixed(2)})`;

    return newHexColor;
};

// Generate a colorMapping from the serieNames and the color palette
// by attributing a color for each serieName
export const generateColorMapping = (
    serieNames: Array<string | number>,
    paletteColors: string[],
): Record<string, string> => {
    const colorMapping: Record<string, string> = {};
    serieNames.forEach(
        (serieName, index) =>
            (colorMapping[serieName] =
                paletteColors[index % paletteColors.length]),
    );
    return colorMapping;
};

// Gets the color associated to a serieName and apply a transparency effect in
// case the metric is an historical amount
export const getSerieColor = (
    serieName: string | number,
    metric: AmountField,
    colorMapping: Record<string, string>,
): string => {
    const color = colorMapping[serieName];
    return metric.includes(HISTORIC_AMOUNT) ? lighten(color, 0.5) : color;
};
